exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-dossier-tsx": () => import("./../../../src/pages/dossier.tsx" /* webpackChunkName: "component---src-pages-dossier-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-legal-mention-tsx": () => import("./../../../src/pages/legal-mention.tsx" /* webpackChunkName: "component---src-pages-legal-mention-tsx" */),
  "component---src-pages-team-tsx": () => import("./../../../src/pages/team.tsx" /* webpackChunkName: "component---src-pages-team-tsx" */)
}

